import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { removeSupplementFromInquiryDraft } from '@api/inquiries';

export const handleRemoveSupplementFromInquiryDraft = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  { id: number }
>('removeSupplementFromInquiryDraft', ({ id }) => removeSupplementFromInquiryDraft(id));
